/**
 * OldDateRangePicker component module.
 * @module shared/components/OldDateRangePicker
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import DateTimeRangeContainer from 'react-advanced-datetimerange-picker';
import styled from 'styled-components/macro';
import {TextInput} from '../../shared';
import './OldDateRangePicker.css';

const _DateRangePickerWrapper = styled.div`
  height: 50px;
`;

/**
 * Datepicker component based on 'react-advanced-datetimerange-picker' to select date range from popup
 * @name OldDateRangePicker
 */
const OldDateRangePicker = props => {
  let local = {
    format: 'MM-DD-YYYY HH:mm',
    sundayFirst: false,
    fromDate: 'From Date',
  };
  let darkMode = false;

  return (
    <_DateRangePickerWrapper>
      <DateTimeRangeContainer
        local={local}
        darkMode={darkMode}
        {...props.dateTimeRange}
      >
        <TextInput
          type='text'
          title='Dates'
          width={'180px'}
          placeholder={props.placeholder}
          dataPoint={{
            name: 'text',
            value: props.placeholder,
          }}
          onChange={() => {}}
        />
      </DateTimeRangeContainer>
    </_DateRangePickerWrapper>
  );
};

export default OldDateRangePicker;

OldDateRangePicker.propTypes = {
  /**
   * Parameters to pass through to {@link https://www.npmjs.com/package/react-advanced-datetimerange-picker }
   */
  dateTimeRange: PropTypes.shape({
    /**
     * Preset date range to select from.
     */
    ranges: PropTypes.object.isRequired,
    /**
     * {Moment Object} Initial Start Date that will be selected, should be a moment object
     */
    start: PropTypes.object.isRequired,
    /**
     * {Moment Object} Initial End Date that will be selected, should be a moment object
     */
    end: PropTypes.object.isRequired,
    // /**
    //  * {Object} Defines a local format for date labels to be shown as. Can also set Sunday to be first day or Monday. Local object accepts format and sunday first params.
    //  */
    // local: PropTypes.object,
    /**
     * {React.func} Function which is called when the apply button is clicked/pressed. Takes two params, that start date and the end date.
     */
    applyCallback: PropTypes.func.isRequired,
    /**
     * Function or expression. Formats the value for display.
     */
    valueFormatter: PropTypes.func,
  }),
  /**
   * {string} Text Place holder in input field.
   */
  placeholder: PropTypes.string,
};
